import React from "react";
import SiteHeader from "./SiteHeader";
import SiteFooter from "./SiteFooter";

export default function SiteLayout({ children }) {
  return (
    <div className="relative min-h-[100dvh] w-full overflow-x-clip bg-bg0 text-ink">
      <div aria-hidden className="pointer-events-none absolute inset-0 -z-10">
        <div className="absolute right-[-200px] top-[40%] h-[420px] w-[420px] rounded-full bg-[radial-gradient(circle_at_center,rgba(85,224,218,0.08),transparent_62%)] blur-2xl" />
        <div className="absolute bottom-[-220px] left-[-160px] h-[420px] w-[420px] rounded-full bg-[radial-gradient(circle_at_center,rgba(11,91,99,0.06),transparent_60%)] blur-2xl" />
      </div>

      <SiteHeader />
      <main className="pt-16">{children}</main>
      <SiteFooter />
    </div>
  );
}
